import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { connectionShape } from "app/lib/shared_prop_types"
import { formatHexColorValue } from "shared/lib/alternate_brand_color"
import ConnectButton from "shared/components/connection_card/connect_button/index"
import parse from "html-react-parser"

import { planNameBadge } from "shared/utils/tiers"

import "./small_applet_card.module.scss"

export default class Meta extends Component {
  render() {
    const { appearDisabled, applet, href, mainService, onAppletClick, showConnectButton, isOnboardingApplet } =
      this.props

    const isConnected = applet.status === "enabled_for_user"
    const background = applet.background_images?.sm_background_image_url ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.3)"
    const handleOnClick = event => {
      event && onAppletClick(event)
      href && window.location.assign(href)
    }
    const needsProBadge = applet.pro_features || applet.intermediate_pro_features

    return (
      <>
        {showConnectButton && (
          <div className="small-applet-connect-button-wrapper">
            <ConnectButton
              smallFlavor
              mainService={mainService}
              onConnectClick={handleOnClick}
              connected={isConnected}
              defaultBgColor={{ background }}
              knobBgColor={{
                boxShadow: "none",
                backgroundColor:
                  (isConnected && !appearDisabled) || isOnboardingApplet
                    ? formatHexColorValue(mainService.brand_color)
                    : "#AAA",
              }}
              knobBgColorForDarkBrands={mainService.brand_color.indexOf("000") !== -1}
              connectButtonMaxFontSize={14}
            />
          </div>
        )}
        <div className={classnames("meta", { badged: needsProBadge, "onboarding-applet": isOnboardingApplet })}>
          {needsProBadge && (
            <span title={`Applet has pro features`} className="card-badge">
              {parse(planNameBadge(applet.pro_features ? "Pro+" : "Pro"))}
            </span>
          )}
        </div>
      </>
    )
  }
}

Meta.propTypes = {
  appearDisabled: PropTypes.bool,
  applet: connectionShape.isRequired,
  href: PropTypes.string,
  isOnboardingApplet: PropTypes.bool,
  mainService: PropTypes.object,
  onAppletClick: PropTypes.func,
  showConnectButton: PropTypes.bool,
}

Meta.defaultProps = {
  appearDisabled: false, // the applet appears disabled to show the user they will lose the applet
  isOnboardingApplet: false,
  showConnectButton: true,
}
